import { useContext, useState } from "react";
import { AppContext } from "../App";
import { CDN_URL } from "../Helpers";

export default function OneJob({ data }) {
  const appContext = useContext(AppContext);
  const [expanded, setExpanded] = useState(false);

  return (
    <article
      className="job-card mShadow1 h-100"
      style={{
        borderRadius: "12px",
        overflow: "hidden",
        cursor: "pointer",
        transition: "all 0.3s ease",
      }}
      onClick={() => setExpanded(!expanded)}
    >
      <div className="p-4">
        <div className="d-flex align-items-start gap-3 mb-3">
          <div className="job-icon" style={{ flexShrink: 0 }}>
            <svg
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="var(--primaryColor)"
            >
              <path d="M20 6h-4v3h4v11H4V4h16v2zM9 11v6H5V11h4zm0-4v4H5V7h4zm6 8v-2h4v-2h-4v-2h4V9h-4V7h4V5h-4V4h4c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V4c0-1.1 .9-2 2-2h8v2H9v2h4v2h-4v4h4v2h-4v2h4v2z" />
            </svg>
          </div>
          <div className="flex-grow-1">
            <h5
              className="job-title mb-1"
              style={{ fontFamily: "FontBold", color: "var(--primaryColor)" }}
            >
              {data.title}
            </h5>
            <p
              className="job-description mb-2"
              style={{ color: "#555", fontSize: "15px" }}
            >
              {data.description}
            </p>
            <div className="job-meta text-muted" style={{ fontSize: "13px" }}>
              Posted: {new Date(data.date).toLocaleDateString()}
            </div>
          </div>
        </div>

        {expanded && (
          <div
            className="job-full-content p-3 border-top"
            style={{ backgroundColor: "#f8f9fa" }}
          >
            <div dangerouslySetInnerHTML={{ __html: data.body }} />
            <div className="text-end mt-3">
              <button className="btn btn-primary btn-sm">Apply Now</button>
            </div>
          </div>
        )}

        <div className="text-end mt-3">
          <button
            className="btn btn-outline-primary btn-sm"
            onClick={(e) => {
              e.stopPropagation();
              setExpanded(!expanded);
            }}
          >
            {expanded ? "Close" : "How to Apply"}
            <i
              className={`fas ${expanded ? "fa-chevron-up ms-1" : "fa-chevron-down ms-1"}`}
            />
          </button>
        </div>
      </div>
    </article>
  );
}
